/* eslint-disable prefer-arrow/prefer-arrow-functions */

import {
  BannersWithCtaLayoutApiModel,
  BuiltInTrayApiModel,
  PageVersionStatusApiModel,
  RecommendationTrayApiModel,
  GenericLayoutApiModel,
  BuiltInTypeApiModel,
  RecommendationTypeApiModel,
  RedeemPageItemApiModel,
  MarketingRedeemPageVersionDetailApiModel,
  RedeemPageItemTypeApiModel,
  PageItemApiModel,
  PageVersionDetailApiModel,
  GenrePageVersionDetailApiModel,
  HeroApiModel,
  DetailItemApiModel,
  GenreItemApiModel,
  CarouselApiModel,
  MarketingAppLandingPageVersionDetailApiModel,
  MarketingAppLandingTrayApiModel,
  MarketingDetailPageVersionDetailApiModel,
  ContentGroupV2ApiModel,
} from '@cxb/editor-stb-api';
import { Country } from '../../domain/country';
import {
  BannersWithCTALayout,
  CarouselLayout,
  DomainLayout,
  GenericLayout,
  MarketingItemLayout,
  StudiosTrayLayout,
} from '../../domain/domain-layouts';
import { Feed } from '../../domain/feed';
import { Genre } from '../../domain/genre';
import {
  AppsAndGamesVersionItem,
  ContentPageVersion,
  ContentPageVersionItem,
  EditorialPageVersionItem,
  GenrePageVersion,
  MarketingPageVersion,
  NonContentPageVersionItem,
  PageVersionCommon,
  PageVersionItem,
  PageVersionItemCommon,
  PageVersionItemType,
  RedeemPageVersion,
} from '../../domain/page-version';
import { Platform } from '../../domain/platform';
import { SimplePageType } from '../../domain/simple-page';
import { UserSegment } from '../../domain/user-segment';
import { PageType } from '../page-type';
import {
  MarketingCtaLayoutApiModel,
  MarketingDetailLayoutApiModel,
  MarketingEmailLayoutApiModel,
  MarketingMultipleContentLayoutApiModel,
  StudioPageItemLayoutApiModel, // TODO:MK: Remove this
} from '../../shared/mock-models/mock-models';

type UnionPageItemApiModel =
  | DetailItemApiModel
  | PageItemApiModel
  | GenreItemApiModel
  | RedeemPageItemApiModel
  | MarketingAppLandingTrayApiModel;

export type UnionPageVersionDetailApiModel =
  | PageVersionDetailApiModel
  | GenrePageVersionDetailApiModel
  | MarketingDetailPageVersionDetailApiModel
  | MarketingRedeemPageVersionDetailApiModel
  | MarketingAppLandingPageVersionDetailApiModel;

export interface VersionedPageMappingDependencies {
  countries: Country[];
  pageType?: PageType; // Only required for APP landing pages
  userSegments: UserSegment[];
  genres: Genre[];
  feeds: Feed[];
  platforms: Platform[];
}

type UnionPageItemType = DetailItemApiModel &
  PageItemApiModel &
  GenreItemApiModel &
  RedeemPageItemApiModel &
  MarketingAppLandingTrayApiModel & { pageItemType?: string; feedId?: string; contentGroup?: ContentGroupV2ApiModel; message?: string };

const nonDraggableRedeemTrays: RedeemPageItemTypeApiModel[] = [
  RedeemPageItemTypeApiModel.GenericVoucherTray,
  RedeemPageItemTypeApiModel.PartnerVoucherTray,
];

const pageItemTypeRecord: Record<string, PageVersionItemType | Record<string, PageVersionItemType>> = {
  CAROUSEL: {
    [GenericLayoutApiModel.Collection]: 'CollectionPageItem',
    [GenericLayoutApiModel.Portrait]: 'PortraitPageItem',
    [GenericLayoutApiModel.Top10]: 'TopTenPageItem',
    [GenericLayoutApiModel.Expandable]: 'ExpandablePageItem',
  },
  CAROUSEL_TRAY: {
    [GenericLayoutApiModel.Collection]: 'CollectionPageItem',
    [GenericLayoutApiModel.Portrait]: 'PortraitPageItem',
    [GenericLayoutApiModel.Top10]: 'TopTenPageItem',
    [GenericLayoutApiModel.Expandable]: 'ExpandablePageItem',
  },
  BUILT_IN: {
    [BuiltInTypeApiModel.WatchlistCarousel]: 'WatchlistPageItem', // CXB
    [BuiltInTypeApiModel.ContinueWatchingCarousel]: 'ContinueWatchingCarouselPageItem', // CXB
    [BuiltInTypeApiModel.FavouriteChannels]: 'FavouriteChannels', // AXB-71
    [BuiltInTypeApiModel.YourReminders]: 'YourReminders', // AXB-84
    [BuiltInTypeApiModel.ContinueWatching]: 'ContinueWatching', // AXB-79 // UXB
    [BuiltInTypeApiModel.Watchlist]: 'Watchlist', // AXB-80 // UXB
    [BuiltInTypeApiModel.TvGuide]: 'TVGuide', // AXB-78
    [BuiltInTypeApiModel.OndemandWatchlist]: 'WatchlistOnDemandTray',
    [BuiltInTypeApiModel.PrimeVideoPlaceHolder]: 'PrimeVideoRecommendationsTray',
    [BuiltInTypeApiModel.OndemandContinueWatching]: 'ContinueWatchingOnDemand', // MYX-86
    [BuiltInTypeApiModel.RecentlyPurchasedContents]: 'RecentlyPurchasedTray',
    [BuiltInTypeApiModel.ExpiringStoreContents]: 'ExpiringStoreContents',
  },
  GENRE_TRAY: 'GenrePageItem',
  STUDIO_TRAY: 'StudiosPageItem',
  MARKETING_CTA_TRAY: 'MarketingCtaPageItem',
  MARKETING_DEVICE_CTA_TRAY: 'DeviceModulePageItem',
  MARKETING_DEVICE_MODULE: 'DeviceModulePageItem',
  MARKETING_DEVICE_MODULE_TRAY: 'DeviceModulePageItem',
  MARKETING_REDEEM_CTA_TRAY: 'RedeemCtaPageItem',
  MARKETING_SPOTLIGHT_CTA_TRAY: 'SpotlightPageItem',
  MARKETING_SPOTLIGHT_TRAY: 'SpotlightPageItem',
  TV_SEASON_CAROUSEL_TRAY: 'SeasonPageItem',
  MARKETING_EMAIL_TRAY: 'EmailCollectorPageItem',
  MARKETING_EMAIL_BLOCKER_TRAY: 'MarketingEmailBlockerPageItem',
  MARKETING_TRENDING_TRAY: 'MarketingTrendingPageItem',
  MARKETING_STUDIO_TRAY: 'MarketingStudioPageItem',
  MARKETING_USP_TRAY: 'MarketingUspPageItem',
  MARKETING_BULLETED_USP_TRAY: 'RedeemUspPageItem',
  MARKETING_REDEEM_BULLETED_USP_TRAY: 'RedeemUspPageItem',
  MARKETING_REDEEM_FAQ_TRAY: 'FaqPageItem',
  MARKETING_KIDS_TRAY: 'MarketingKidsPageItem',
  MARKETING_DETAIL_TRAY: 'DetailedPageMarketingBannerPageItem',
  MARKETING_HERO_TRAY: 'MarketingHeroPageItem',
  MARKETING_FAQ_TRAY: 'FaqPageItem',
  MARKETING_APP_LANDING_TRAY: 'AppLandingCotvPageItem', // TODO: Is this correct here?
  MARKETING_REDEEM_GENERIC_VOUCHER_TRAY: 'RedeemGenericVoucherPageItem',
  MARKETING_REDEEM_PARTNER_VOUCHER_TRAY: 'RedeemPartnerVoucherPageItem',
  MARKETING_VIDEO_TRAY: 'MarketingVideoTray',
  MARKETING_BAR_TRAY: 'MarketingBarTray',
  TV_SEASON_TRAY: 'SeasonPageItem',
  SEASON_TRAY: 'SinglePhotoSeasonPageItem',
  RECOMMENDATION_TRAY: {
    [RecommendationTypeApiModel.BecauseYouWatched]: 'RecommendationBecauseYouWatchedPageItem',
    [RecommendationTypeApiModel.BecauseOthersWatched]: 'RecommendationPeopleLikeYouWatchPageItem',
    [RecommendationTypeApiModel.MoviesOthersLikeYouWatched]: 'RecommendationPeopleLikeYouWatchMoviesPageItem',
    [RecommendationTypeApiModel.SeriesOthersLikeYouWatched]: 'RecommendationPeopleLikeYouWatchSeriesPageItem',
    [RecommendationTypeApiModel.BecauseYouWatchedGenre]: 'RecommendationBecauseYouWatchGenrePageItem',
    [RecommendationTypeApiModel.Trending]: 'RecommendationTrendingPageItem', // AXB-929
    [RecommendationTypeApiModel.TrendingMovies]: 'RecommendationTrendingMoviesPageItem', // AXB-930
    [RecommendationTypeApiModel.TrendingSeries]: 'RecommendationTrendingSeriesPageItem', // AXB-931
    [RecommendationTypeApiModel.TrendingWithLayout]: 'RecommendationTrendingWithLayoutPageItem', // AXB-929
    [RecommendationTypeApiModel.TrendingMovies]: 'RecommendationTrendingMoviesPageItem',
    [RecommendationTypeApiModel.TrendingSeries]: 'RecommendationTrendingSeriesPageItem',
    [RecommendationTypeApiModel.PersonalizedSwimLane]: 'RecommendationTopPicksPageItem',
    [RecommendationTypeApiModel.PersonalizedSwimLaneMoviesOnly]: 'RecommendationTopPicksMoviesPageItem',
    [RecommendationTypeApiModel.PersonalizedSwimLaneSeriesOnly]: 'RecommendationTopPicksSeriesPageItem',
    [RecommendationTypeApiModel.DontMiss]: 'RecommendationDontMissPageItem',
    [RecommendationTypeApiModel.BecauseOthersWatchedDownloadable]: 'RecommendationPeopleLikeYouWatchDownloadablePageItem',
    [RecommendationTypeApiModel.MoviesOthersLikeYouWatchedDownloadable]: 'RecommendationPeopleLikeYouWatchDownloadableMoviesPageItem',
    [RecommendationTypeApiModel.SeriesOthersLikeYouWatchedDownloadable]: 'RecommendationPeopleLikeYouWatchDownloadableSeriesPageItem',
    [RecommendationTypeApiModel.PersonalizedSwimLaneDownloadable]: 'RecommendationTopPicksDownloadablePageItem',
    [RecommendationTypeApiModel.PersonalizedSwimLaneMoviesOnlyDownloadable]: 'RecommendationTopPicksDownloadableMoviesPageItem',
    [RecommendationTypeApiModel.PersonalizedSwimLaneSeriesOnlyDownloadable]: 'RecommendationTopPicksDownloadableSeriesPageItem',
    [RecommendationTypeApiModel.MostDownloadedMovies]: 'RecommendationMostDownloadedMoviesPageItem',
    [RecommendationTypeApiModel.MostDownloadedSeries]: 'RecommendationMostDownloadedSeriesPageItem',
  },
  HERO: 'HeroPageItem',
  INSTALLED_APPS_TRAY: 'AppsAndGamesInstalledApps',
  RECOMMENDED_APPS_TRAY: 'AppsAndGamesRecommendedApps',
  RECENTLY_WATCHED_CHANNEL_TRAY: 'RecentlyWatchedTV',
  OTHER_APPS_TRAY: 'TitleImagePortraitTray',
  TOP_TEN_VOD_CONTENT_TRAY: 'TopTenOnOSNPlusPosterArtTray',
  SPOTLIGHT: 'HeroSpotlight',
  SEARCH_TAGS_TRAY: 'SearchTagsTray', // AXB-172
  VOD_CONTENT_TRAY: 'StreamingContentTray',
  CURRENTLY_ON_TV_TRAY: 'CurrentlyOnTvTray',
  TV_CHANNEL_LOGO_TRAY: 'ChannelLogoTray',
  TOP_TEN_ON_LIVE_TV_TRAY: 'TopTenOnLiveTvTray',
  UPCOMING_LIVE_TV_CONTENT_TRAY: 'ComingSoonForLiveTvTray',
  FULLSCREEN_TRAY: 'FullscreenTray',
  BANNERS_WITH_CTA_TRAY: 'BannersTrayWithCta',
  BANNERS_TRAY: 'CarouselTray',
  COLLECTIONS_TRAY: 'CarouselBannerTray',
  CHANNEL_SPECIFIC_UPCOMING_TRAY: 'UpcomingOnSpecificTvChannelTray',
  RECOMMENDED_CHANNELS_TRAY: 'RecommendedChannelsTray',
  MARKETING_BANNER_TRAY: 'MarketingBannerTray',
  CATCH_UP_TRAY: 'CatchUpTray',
  CHANNEL_SPECIFIC_CATCH_UP_TRAY: 'ChannelSpecificCatchUpTray',
  LANDSCAPE_TRAY: 'LandscapeTray',
  CATEGORY_TRAY: 'OndemandCategoryTray',
  ONDEMAND_BANNER_TRAY: 'OndemandBannerTray',
  MIXED_SEARCH_TAG_TRAY: 'MixedSearchTagTray',
};

const layoutRecord: Record<
  | MarketingCtaLayoutApiModel
  | MarketingDetailLayoutApiModel
  | MarketingEmailLayoutApiModel
  | StudioPageItemLayoutApiModel
  | MarketingMultipleContentLayoutApiModel
  | BannersWithCtaLayoutApiModel
  | GenericLayoutApiModel,
  DomainLayout
> = {
  [MarketingCtaLayoutApiModel.Left]: MarketingItemLayout.CTA_LEFT,
  [MarketingCtaLayoutApiModel.Right]: MarketingItemLayout.CTA_RIGHT,
  [MarketingDetailLayoutApiModel.AlignedLeft]: MarketingItemLayout.DETAILED_PAGE_BANNER_LEFT,
  [MarketingDetailLayoutApiModel.AlignedRight]: MarketingItemLayout.DETAILED_PAGE_BANNER_RIGHT,
  [MarketingDetailLayoutApiModel.Centered]: MarketingItemLayout.DETAILED_PAGE_BANNER_CENTER,
  [MarketingEmailLayoutApiModel.AlignedLeft]: MarketingItemLayout.EMAIL_LEFT,
  [MarketingEmailLayoutApiModel.AlignedRight]: MarketingItemLayout.EMAIL_RIGHT,
  [MarketingEmailLayoutApiModel.Centered]: MarketingItemLayout.EMAIL_CENTERED,
  [StudioPageItemLayoutApiModel.Large]: StudiosTrayLayout.Large,
  [StudioPageItemLayoutApiModel.Small]: StudiosTrayLayout.Small,
  [StudioPageItemLayoutApiModel.Medium]: StudiosTrayLayout.Medium,
  [MarketingMultipleContentLayoutApiModel.Landscape]: MarketingItemLayout.MULTIPLE_CONTENT_LANDSCAPE,
  [MarketingMultipleContentLayoutApiModel.Portrait]: MarketingItemLayout.MULTIPLE_CONTENT_PORTRAIT,
  [GenericLayoutApiModel.Collection]: CarouselLayout.Collection,
  [GenericLayoutApiModel.Portrait]: CarouselLayout.Portrait,
  [GenericLayoutApiModel.Landscape]: CarouselLayout.Landscape,
  [GenericLayoutApiModel.Top10]: CarouselLayout.Top10,
  [GenericLayoutApiModel.Expandable]: CarouselLayout.Expandable,
  [GenericLayoutApiModel.TwoCards]: GenericLayout.TwoCards,
  [GenericLayoutApiModel.ThreeCards]: GenericLayout.ThreeCards,
  [GenericLayoutApiModel.FourCards]: GenericLayout.FourCards,
  [GenericLayoutApiModel.FiveCards]: null,
  [GenericLayoutApiModel.NoThumbnails]: null,
  [BannersWithCtaLayoutApiModel.ThreeThumbnails]: BannersWithCTALayout.ThreeCards,
  [BannersWithCtaLayoutApiModel.TwoThumbnails]: BannersWithCTALayout.TwoCards,
  // TODO:CXBMERGE:AB WTH are these below?
  [GenericLayoutApiModel.Top10]: null,
  [GenericLayoutApiModel.Landscape]: null,
  [GenericLayoutApiModel.Portrait]: null,
  [GenericLayoutApiModel.Collection]: null,
  [GenericLayoutApiModel.Expandable]: null,
  // [GenericLayoutApiModel.Small]: null,
  // [GenericLayoutApiModel.Medium]: null,
  // [GenericLayoutApiModel.Large]: null,
  [GenericLayoutApiModel.Centered]: MarketingItemLayout.EMAIL_CENTERED,
  [GenericLayoutApiModel.Left]: MarketingItemLayout.CTA_LEFT,
  [GenericLayoutApiModel.Right]: MarketingItemLayout.CTA_RIGHT,
  COLLECTION_LANDSCAPE: StudiosTrayLayout.Small,
  COLLECTION_PORTRAIT: StudiosTrayLayout.Small,
  LANDSCAPE_SMALL: StudiosTrayLayout.Small,
  LANDSCAPE_LARGE: StudiosTrayLayout.Small,
  PORTRAIT_SMALL: StudiosTrayLayout.Small,
  PORTRAIT_LARGE: StudiosTrayLayout.Small,
  MICK_MACK: StudiosTrayLayout.Small,
};

type NestedDiscriminatorKeys = keyof (Pick<BuiltInTrayApiModel, 'builtInType'> &
  Pick<RecommendationTrayApiModel, 'recommendationType'> &
  Pick<CarouselApiModel, 'layout'>);

// Order is important, as reco trays have a layout as well and checking it before
// the recommendationType means a content tray could get infered as a reco tray
const nestedDiscriminatorKeys: NestedDiscriminatorKeys[] = ['builtInType', 'recommendationType', 'layout'];

function pageVersionItemMapper(
  pageItem: UnionPageItemType,
  deps: VersionedPageMappingDependencies,
  partialResult: Partial<PageVersionItem> = {}
): PageVersionItem {
  const topLevelInferedType = pageItemTypeRecord[pageItem.pageItemType];
  const secondLevelInferedType =
    typeof topLevelInferedType === 'object'
      ? (nestedDiscriminatorKeys
          .map((key) => topLevelInferedType[pageItem[key]])
          .find((it) => typeof it === 'string') as PageVersionItemType)
      : undefined;

  const trayType =
    pageItem.pageItemType === 'RECOMMENDATION_TRAY' && !secondLevelInferedType
      ? 'RecommendationEditorialPageItem'
      : secondLevelInferedType ?? (topLevelInferedType as PageVersionItemType);

  const commonProperties: PageVersionItemCommon = {
    id: pageItem.id,
    trayType,
    name: pageItem.internalName || pageItem.nameLocalized?.en,
    draggable: true,
    order: pageItem.order,
    visible: pageItem.visible,
    countries: deps.countries.filter((it) => pageItem.countries?.map((country) => country.id)?.includes(it.id)),
    userSegments: deps.userSegments.filter((it) => pageItem.userSegments?.map((userSegment) => userSegment.id)?.includes(it.id)),
    layout: layoutRecord[pageItem['layout']],
    scheduledFrom: pageItem.scheduledFrom,
    scheduledTo: pageItem.scheduledTo,
    platforms: deps.platforms.filter((it) => pageItem.platforms?.map((platform) => platform.id)?.includes(it.id)),
    ...partialResult,
  };

  if (trayType === 'CarouselBannerTray' || trayType === 'CarouselTray') {
    const carouselApiModel = pageItem;

    const result: ContentPageVersionItem = {
      ...commonProperties,
      trayType,
      relatedFeed: deps.feeds.find((it) => it.id === carouselApiModel.feedId),
      contentGroup: carouselApiModel.contentGroup,
    };

    return result;
  }

  if (
    trayType === 'PortraitPageItem' ||
    trayType === 'TopTenPageItem' ||
    trayType === 'ExpandablePageItem' ||
    trayType === 'CollectionPageItem' ||
    trayType === 'BannersTrayWithCta' ||
    trayType === 'FullscreenTray' ||
    trayType === 'SearchTagsTray' ||
    trayType === 'StreamingContentTray' ||
    trayType === 'TopTenOnOSNPlusPosterArtTray'
  ) {
    const carouselApiModel = pageItem;

    const result: ContentPageVersionItem = {
      ...commonProperties,
      trayType,
      relatedFeed: deps.feeds.find((it) => it.id === carouselApiModel.feedId),
    };

    return result;
  }

  if (trayType === 'LandscapeTray') {
    const landscapeTray = pageItem;

    return {
      ...commonProperties,
      trayType,
      contentGroup: landscapeTray.contentGroup,
    };
  }

  if (trayType === 'RecommendationEditorialPageItem') {
    const result: EditorialPageVersionItem = {
      ...commonProperties,
      trayType,
      message: (pageItem as RecommendationTrayApiModel).message,
    };

    return result;
  }

  // TODO:AB not sure if this is necessary here
  if (trayType === 'AppsAndGamesInstalledApps' || trayType === 'AppsAndGamesRecommendedApps') {
    const result: AppsAndGamesVersionItem = {
      ...commonProperties,
      trayType,
      subType: trayType,
    };

    return result;
  }

  return commonProperties as NonContentPageVersionItem;
}

function contentAndMarketingPageItemMapper(
  page: UnionPageVersionDetailApiModel,
  pageItem: PageItemApiModel & { pageItemType: string },
  deps: VersionedPageMappingDependencies
): PageVersionItem {
  return pageVersionItemMapper(pageItem, deps);
}

function collectionPageItemMapper(
  page: UnionPageVersionDetailApiModel,
  pageItem: PageItemApiModel & { pageItemType: string },
  deps: VersionedPageMappingDependencies
): PageVersionItem {
  return pageVersionItemMapper(pageItem, deps);
}

function detailPageItemMapper(
  page: UnionPageVersionDetailApiModel,
  pageItem: DetailItemApiModel,
  deps: VersionedPageMappingDependencies
): PageVersionItem {
  return pageVersionItemMapper({ ...pageItem, nameLocalized: { en: '', ar: '' }, trayCategory: '' }, deps);
}

// eslint-disable-next-line sonarjs/no-identical-functions
function genrePageItemMapper(
  page: UnionPageVersionDetailApiModel,
  pageItem: GenreItemApiModel,
  deps: VersionedPageMappingDependencies
): PageVersionItem {
  return pageVersionItemMapper({ ...pageItem, nameLocalized: { en: '', ar: '' }, trayCategory: '' }, deps);
}

function redeemPageItemMapper(
  page: UnionPageVersionDetailApiModel,
  pageItem: RedeemPageItemApiModel & { pageItemType: RedeemPageItemTypeApiModel },
  deps: VersionedPageMappingDependencies
): PageVersionItem {
  return pageVersionItemMapper(
    { ...pageItem, userSegments: [], countries: [], countryGroups: [], platforms: [], nameLocalized: { en: '', ar: '' }, trayCategory: '' },
    deps,
    {
      draggable: !nonDraggableRedeemTrays.includes(pageItem.pageItemType),
    }
  );
}

function appLandingPageItemMapper(
  page: UnionPageVersionDetailApiModel,
  pageItem: MarketingAppLandingTrayApiModel,
  deps: VersionedPageMappingDependencies
): PageVersionItem {
  const pageItemType: PageVersionItemType = page.internalName.toLowerCase().includes('cotv')
    ? 'AppLandingCotvPageItem'
    : 'AppLandingMobilePageItem';
  return pageVersionItemMapper({ ...pageItem, order: null, visible: true, nameLocalized: { en: '', ar: '' }, trayCategory: '' }, deps, {
    trayType: pageItemType,
  });
}

function mapApiPageToPage<T extends SimplePageType>(
  page: UnionPageVersionDetailApiModel,
  type: T,
  pageType: PageType,
  deps: VersionedPageMappingDependencies,
  pageItemMapper: (
    page: UnionPageVersionDetailApiModel,
    pageItem: UnionPageItemApiModel,
    deps: VersionedPageMappingDependencies
  ) => PageVersionItem
): PageVersionCommon<T> {
  const draftPageVersion = page.pageVersions.find((it) => it.status === PageVersionStatusApiModel.Draft);
  const livePageVersion = page.pageVersions.find((it) => it.status === PageVersionStatusApiModel.Published);

  const pageStatus = page.pageVersions.find((pageVersion) => page.id === pageVersion.id).status;

  return {
    type,
    id: page.pageId,
    draftPageId: draftPageVersion?.id,
    livePageId: livePageVersion?.id,
    slug: page.slug,
    name: page.internalName,
    lastPublishedAt: page.updatedAt,
    pageType,
    pageStatus,
    pageItems: page.items
      .map((it) => pageItemMapper(page, it, deps))
      .filter((it, index) => {
        if (!it.trayType) {
          console.error('Unknown page item', page.items[index]?.['pageItemType']);
          return false;
        }

        return true;
      }),
    englishTitle: page.nameLocalized.en,
    arabicTitle: page.nameLocalized.ar,
    metaTags: (page as PageVersionDetailApiModel).metaTags ?? {},
    seoTitle: (page as PageVersionDetailApiModel).seoTitle ?? { en: '', ar: '' },
    seoDescription: (page as PageVersionDetailApiModel).seoDescription ?? { en: '', ar: '' },
  };
}

function mapHeroItem(hero: HeroApiModel): PageItemApiModel & { pageItemType: 'HERO' } {
  return {
    id: hero.id,
    slug: hero.slug,
    countries: [],
    userSegments: hero.userSegments,
    internalName: hero.nameLocalized?.en,
    order: undefined,
    countryGroups: [],
    visible: true,
    scheduledFrom: undefined,
    scheduledTo: undefined,
    pageItemType: 'HERO',
    platforms: hero.platforms,
    nameLocalized: hero.nameLocalized, //TODO:MK GABOR'S TASK
    trayCategory: '',
  };
}

export function mapApiContentPageDetailsToDomain(
  page: PageVersionDetailApiModel,
  deps: VersionedPageMappingDependencies
): ContentPageVersion {
  page = { ...page };
  const mappedHeroItems: PageItemApiModel[] = page.heroItems?.map(mapHeroItem) ?? [];
  page.items = [...mappedHeroItems, ...page.items];

  return mapApiPageToPage(page, 'Content', PageType.content, deps, contentAndMarketingPageItemMapper);
}

export function mapApiMarketingLandingPageDetailsToDomain(
  page: PageVersionDetailApiModel,
  deps: VersionedPageMappingDependencies
): MarketingPageVersion {
  return mapApiPageToPage(page, 'Marketing', PageType.marketingDetails, deps, contentAndMarketingPageItemMapper);
}

export function mapApiGenrePageDetailsToDomain(
  page: GenrePageVersionDetailApiModel,
  deps: VersionedPageMappingDependencies
): GenrePageVersion {
  const mappedHeroItems: PageItemApiModel[] = page.heros.map(mapHeroItem);
  page.items = [...mappedHeroItems, ...page.items];

  return {
    ...mapApiPageToPage(page, 'Genre', PageType.genre, deps, genrePageItemMapper),
    genre: deps.genres.find((it) => page.genre.id === it.id),
  };
}

export function mapApiMarketingDetailsPageDetailsToDomain(
  page: MarketingDetailPageVersionDetailApiModel,
  deps: VersionedPageMappingDependencies
): MarketingPageVersion {
  return mapApiPageToPage(page, 'Marketing', PageType.marketingDetails, deps, detailPageItemMapper);
}

export function mapApiRedeemPageDetailsToDomain(
  page: MarketingRedeemPageVersionDetailApiModel,
  deps: VersionedPageMappingDependencies
): RedeemPageVersion {
  const basePage: PageVersionCommon<'Redeem'> = mapApiPageToPage(page, 'Redeem', getRedeemPageSubtype(page), deps, redeemPageItemMapper);
  const pageCountryIds = page.countries.map((it) => it.id);
  const pageUserSegmentIds = page.userSegments.map((it) => it.id);
  const pagePlatformIds = page.platforms.map((it) => it.id);

  return {
    ...basePage,
    countries: deps.countries.filter((it) => pageCountryIds.includes(it.id)),
    userSegments: deps.userSegments.filter((it) => pageUserSegmentIds.includes(it.id)),
    platforms: deps.platforms.filter((it) => pagePlatformIds.includes(it.id)),
  };
}

export function mapApiAppLandingPageDetailsToDomain(
  page: MarketingAppLandingPageVersionDetailApiModel,
  deps: VersionedPageMappingDependencies
): MarketingPageVersion {
  return mapApiPageToPage(page, 'Marketing', deps.pageType, deps, appLandingPageItemMapper);
}

function getRedeemPageSubtype(page: MarketingRedeemPageVersionDetailApiModel): PageType {
  const pageItems = page.items as (RedeemPageItemApiModel & { pageItemType: RedeemPageItemTypeApiModel })[];

  if (page?.slug?.includes('generic-redeem-page')) {
    return !pageItems.find((it) => it.pageItemType === RedeemPageItemTypeApiModel.GenericVoucherTray)
      ? PageType.redeemGenericIncomplete
      : PageType.redeem;
  } else {
    return !pageItems?.find((it) => it.pageItemType === RedeemPageItemTypeApiModel.PartnerVoucherTray)
      ? PageType.redeemPartnerIncomplete
      : PageType.redeem;
  }
}
